



























































































































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import Multiselect from "vue-multiselect";
import get from "lodash-es/get";
import debounce from "lodash-es/debounce";
import isEmpty from "lodash-es/isEmpty";
import find from "lodash-es/find";
import orderBy from "lodash-es/orderBy";
import moment from "moment";
import DateRangePicker from "../../components/DateRangePicker.vue";

import {
  AutobedrijfViewModel,
  DropdownItemStringViewModel,
  DropdownItemModel,
  FixedPeriodType,
  FilterValuesPeriod,
} from "../../TypeScriptModels";

interface DashboardSettingsOrderViewModel {
  CustomStartDate: string | null;
  CustomEndDate: string | null;
  SelectedPeriod: FixedPeriodType;
  SelectedAutobedrijven: string[];
  SelectedVestigingen: string[];
  SelectedModellen: string[];
  SelectedZones: number[];
}

interface DashboardOrdersOptionViewModel {
  Perioden: DropdownItemModel[];
  Zones: DropdownItemModel[];
  Autobedrijven: AutobedrijfViewModel[];
  Vestigingen: DropdownItemStringViewModel[];
  Modellen: DropdownItemStringViewModel[];
}

export interface FilterOrderValues {
  period: FilterValuesPeriod | null;
  zonesValue: any[];
  autobedrijvenValue: any[];
  vestigingenValue: any[];
  modellenValue: any[];
  merkenValue: any[];
  periodFromDate: Date;
  periodToDate: Date;
  customFromDate: Date;
  customToDate: Date;
}

export default Vue.extend({
  props: {
    selectedOptions: {
      required: true,
      type: Object as () => FilterOrderValues,
      default: {
        period: {} as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        modellenValue: [] as any[],
        merkenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
      } as FilterOrderValues,
    },
  },

  data() {
    return {
      initialised: false,
      options: {
        Perioden: [] as DropdownItemModel[],
        Modellen: [] as DropdownItemStringViewModel[],
        Vestigingen: [] as DropdownItemStringViewModel[],
        Zones: [] as DropdownItemModel[],
        Autobedrijven: [] as AutobedrijfViewModel[],
      } as DashboardOrdersOptionViewModel,
      handlePreferenceChangedDebounced: null as null | Function,
      autobedrijvenOptionsUpdate: 0,
      vestigingenOptionsUpdate: 0,
    };
  },

  computed: {
    zonesOptions(): null | any[] {
      return orderBy(get(this.options, "Zones", []), ["Omschrijving"], ["asc"]);
    },

    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    autobedrijvenOptions(): any[] {
      let update = this.autobedrijvenOptionsUpdate;
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );

      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      return orderBy(autobedrijven, ["Omschrijving"], ["asc"]);
    },

    modellenOptions(): null | any[] {
      return orderBy(
        get(this.options, "Modellen", []),
        ["Omschrijving"],
        ["asc"]
      );
    },

    vestigingenOptions(): null | any[] {
      let update = this.vestigingenOptionsUpdate;
      let vestigingen = get(this.options, "Vestigingen", []);

      if (!isEmpty(this.autobedrijvenOptions) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((vestiging) =>
          (this.autobedrijvenOptions as any[]).some(
            (a: any) => String(a.Id) === String(vestiging.GroupId)
          )
        );
      }

      // alleen vestigingen tonen die bij de geselecteerde autobedrijven horen
      let selectedAutobedrijven = this.selectedOptions.autobedrijvenValue;

      if (!isEmpty(selectedAutobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((vestiging) =>
          (selectedAutobedrijven as any[]).some(
            (autobedrijf: any) =>
              String(autobedrijf.Id) === String(vestiging.GroupId)
          )
        );
      }

      return orderBy(vestigingen, ["Omschrijving"], ["asc"]);
    },

    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },

    makeOptions(): DropdownItemStringViewModel[] {
      if (this.multipleMakes) {
        return (this.$store.getters.importeurMerken as string[]).map((merk) => {
          return { Id: merk, Omschrijving: merk };
        });
      }
      return [];
    },
  },
  methods: {
    getSavesPreferences() {
      axios
        .get("/api/backend/v1/identity/preferences/orders")
        .then((response) => {
          if (!!response && !!response.data && !!response.data.FilterSettings) {
            const filtersettings = response.data
              .FilterSettings as DashboardSettingsOrderViewModel;

            if (filtersettings.SelectedAutobedrijven !== undefined) {
              this.selectedOptions.autobedrijvenValue = (get(
                this.options,
                "Autobedrijven",
                []
              ) as any[]).filter(
                (a) => filtersettings.SelectedAutobedrijven.indexOf(a.Id) > -1
              );
            }

            this.selectedOptions.vestigingenValue = (get(
              this.options,
              "Vestigingen",
              []
            ) as any[]).filter(
              (v) => filtersettings.SelectedVestigingen.indexOf(v.Id) > -1
            );

            this.selectedOptions.zonesValue = (get(
              this.options,
              "Zones",
              []
            ) as any[]).filter(
              (z) => filtersettings.SelectedZones.indexOf(z.Id) > -1
            );

            this.selectedOptions.modellenValue = (get(
              this.options,
              "Modellen",
              []
            ) as any[]).filter(
              (m) => filtersettings.SelectedModellen.indexOf(m.Id) > -1
            );

            let period = find(
              get(this.options, "Perioden", []),
              (p) => p.Id === filtersettings.SelectedPeriod
            );

            if (!!period) {
              this.selectedOptions.period = period;
            }

            this.selectedOptions.customFromDate = moment(
              filtersettings.CustomStartDate as string
            ).local().startOf("day").toDate();

            this.selectedOptions.customToDate = moment(
              filtersettings.CustomEndDate as string
            ).local().endOf("day").toDate();
          } //preferences set

          this.initialised = true;
          this.$emit("initialised", true);
        })
        .catch((error) => {});
    },

    handlePreferencesChanged: function() {
      if (!this.handlePreferenceChangedDebounced) {
        this.handlePreferenceChangedDebounced = debounce(() => {
          this.reduceSelectedOptions();
          this.persistPreferences();
          this.$emit("preferences-changed", true);
        }, 300);
      }

      this.handlePreferenceChangedDebounced();
    },

    handleDateoptionsChanged(perioden: { Id: number; Omschrijving: string }[]) {
      this.options.Perioden = perioden;
    },
    onDateRangePickerMounted(perioden: { Id: number; Omschrijving: string }[]) {
      this.handleDateoptionsChanged(perioden);
      this.fillFilters();
    },
    fillFilters() {
      axios
        .get("/api/backend/v1/dashboard/orders/options")
        .then((response) => {
          if (!!response && !!response.data) {
            let { Vestigingen, Modellen, Zones, Autobedrijven } = response.data;

            this.options.Vestigingen = Vestigingen;
            this.options.Modellen = Modellen;
            this.options.Zones = Zones;
            this.options.Autobedrijven = Autobedrijven;
            this.getSavesPreferences();
          }
        })
        .catch((error) => {});
    },

    reduceSelectedOptions(): void {
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );

      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      if (!isEmpty(zones)) {
        let previous = isEmpty(this.selectedOptions.autobedrijvenValue)
          ? 0
          : this.selectedOptions.autobedrijvenValue.length;

        // verwijder geselecteerde autobedrijven als die buiten het huidige zone filter vallen
        this.selectedOptions.autobedrijvenValue = this.selectedOptions.autobedrijvenValue.filter(
          (aValue: any) =>
            zones.some((zone: any) => String(zone.Id) === String(aValue.ZoneId))
        );
        let current = isEmpty(this.selectedOptions.autobedrijvenValue)
          ? 0
          : this.selectedOptions.autobedrijvenValue.length;

        if (current != previous) this.autobedrijvenOptionsUpdate++;
      }

      /////////////////////////////////////////////////////////////////////////

      let vestigingen = get(this.options, "Vestigingen", []);

      if (!isEmpty(autobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((vestiging) =>
          autobedrijven.some(
            (a: any) => String(a.Id) === String(vestiging.GroupId)
          )
        );
      }

      // alleen vestigingen tonen die bij de geselecteerde autobedrijven horen
      let selectedAutobedrijven = this.selectedOptions.autobedrijvenValue;

      if (!isEmpty(selectedAutobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((vestiging) =>
          (selectedAutobedrijven as any[]).some(
            (autobedrijf: any) =>
              String(autobedrijf.Id) === String(vestiging.GroupId)
          )
        );
      }

      let previous = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      // update selected vestigingen als die buiten het huidige filter vallen
      this.selectedOptions.vestigingenValue = this.selectedOptions.vestigingenValue.filter(
        (vValue: any) =>
          vestigingen.some((v: any) => String(v.Id) === String(vValue.Id))
      );

      let current = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      if (current != previous) this.vestigingenOptionsUpdate++;
    },

    persistPreferences() {
      if (!this.initialised) return;

      let settings = {
        CustomStartDate: (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString(),
        CustomEndDate: (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString(),	  	
        SelectedPeriod: get(
          this.selectedOptions,
          "period.Id",
          FixedPeriodType.ThisYear
        ),
        SelectedAutobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedVestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedZones: get(
          this.selectedOptions as Object,
          "zonesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedModellen: get(
          this.selectedOptions as Object,
          "modellenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
      } as DashboardSettingsOrderViewModel;

      axios.post("/api/backend/v1/identity/preferences/orders", settings, {
        headers: { "Content-Type": "application/json" },
      });
    },
  },
  components: {
    Multiselect,
    DateRangePicker,
  },
});
